import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./MobileAppUpdateBillingView.component.scss";
import { Link } from "react-router-dom";
import Loader from "../../common/loader/Loader";

import ErrorView from "../../common/error-view/ErrorView";
import { AppLinks } from "../../../constants/app-links";

export class MobileAppUpdateBillingView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.hideLoader = this.hideLoader.bind(this);

    this.billingStatus = '';
  }
  
  hideLoader() {
    this.setState({loadingForm:false})
  }

  dateSuffix = (day) => {
    let j = day % 10,
      k = day % 100;
    if (j === 1 && k !== 11) {
      return day + "st";
    }
    if (j === 2 && k !== 12) {
      return day + "nd";
    }
    if (j === 3 && k !== 13) {
      return day + "rd";
    }
    return day + "th";
  }


  openManagePaymentMethods = () => {
    this.props.openManagePayments('managePaymentMethods');
  }

  openManageRecurringPayments = () => {
    this.props.openManagePayments('manageRecurringPayments');
  }

  componentDidMount() {

    var self = this;

    setTimeout(() => {
      this.hideLoader();
    },500);

    switch (this.props.userAccountDetails.Status) {
      case 'Active':
        this.billingStatus = 'Current';
        break;
      case 'Suspended':
        this.billingStatus = 'Suspended';
        break;
      case 'Cancel Full':
      case 'Cancel Prorata':
        this.billingStatus = 'Canceled';
        break;
      default:
        this.billingStatus = 'Unknown';
    }
  }

  render () {
    return (
    <div>
      <div className="d-flex flex-column update-billing-container">
        {this.props.serverError && <ErrorView>{this.props.errorText ? this.props.errorText :
        <span>Unable to update billing details due to an error. Please Contact Us.</span>
        }</ErrorView>}
        {this.props.userAccountDetails ?
          (<div>
                        <h1 className="page-title mobile-manage-payment-label">Manage Payments</h1>
            <div className="payment-section m-4">
                            <div className="mobile-card-header-label">
                                <img class="payment-icon" src="/assets/images/dollar_icon.svg" alt="Payment" />Payment Information
                            </div>
            
                <div className="mobile-card-body">
                                <div className="mobile-card-payment-label">BILLING STATUS</div>
                                <div className="mobile-card-payment-value" id="BillingStatus">{ this.billingStatus }</div>
              
                                <div className="mobile-card-payment-label">MONTHLY PREMIUM</div>
                                <div className="mobile-monthly-premium-value">${ this.props.userAccountDetails.MonthlyPremium.substr(1) } <span className="mobile-monthly-detail-label">(on the 
                      <span id="BillingDay"> { this.dateSuffix(this.props.userAccountDetails.BillingDay) }</span> of each month)</span></div>
              
                  <div className="fee-info">
                                    <div className="mobile-card-Fees-Title">About card processing fees:</div>
                  <div className="mobile-card-fee-description">
                      Subject to state law requirements, card payments will be processed by One Inc, a third-party payment processor,
                      and a processing fee of 2.99% will be charged for using their digital payment platform. To avoid the fee associated with
                      paying by card through the One Inc. platform, you can pay via bank account (ACH) instead.
                  </div>
                  </div>
                                
                  <div className="mobile-button-container">
                                    <button className="mobile-btn-primary" onClick={this.openManagePaymentMethods}>Manage Payment Methods</button>
                                    <button className="mobile-btn-outline" onClick={this.openManageRecurringPayments}>Manage Recurring Payments</button>
                                    </div>
                 
                </div>
            </div>
           
            {/*<div className="m-4">*/}
            {/*  <hr className="d-none d-md-block" />*/}
            {/*  <label className="d-none d-md-block note-text ">*/}
            {/*    Note: Updating your billing address does not change your*/}
            {/*    physical address.*/}
            {/*  </label>*/}
            {/*  <hr className="d-none d-md-block margin-bottom" />*/}
            {/*</div>*/}
        </div>
        )
         : (
          this.props.userAccountFetchError && (
            <ErrorView>
              {this.props.userAccountFetchError.errorMessage ||
                "Unable to fetch information right now."}
            </ErrorView>
          )
        )}
        {(this.props.sendingToServer || this.props.userAccountDetailsFetching || this.state.loadingForm) && (
          <Loader position="absolute" fullPage={true} zIndex="300" />
        )}
      </div>
    </div>
  );
        }
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
    },
    dispatch
  )
});

export default connect(
  mapDispatchToProps
)(MobileAppUpdateBillingView);
